module.exports = "/images/Create packages - 2.jpg";